import { render } from "./CardAttachments.vue?vue&type=template&id=a24d6e5a"
import script from "./CardAttachments.vue?vue&type=script&lang=js"
export * from "./CardAttachments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Route\\Vue\\dashboard-tahsel-metronic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__